import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import Form from './Form';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewProductModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( { product } ) => {
        this.setState( { fetching: true } );
        this.props.create( { ...product } )
        .then((newProduct) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newProduct );
        });
    }



    render() {
        const initialValues = {};
        return (
            <DLModal title='New Video'
            closeHandler={ this.props.closeModal }>
                <div>
                    <Form onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        create: ( data ) => {
            return dAPI.post( '/admin/videos', data );
        },
        updateProduct: ( id, data ) => {
            return dAPI.patch( `/admin/desires/${ id }`, data );
        },
        addTagToProduct: ( desireid, newTag ) => {
            return dAPI.post( `/desires/${ desireid }/tag`, { tag: newTag } );
        },
        deleteTagFromProduct: ( desireid, tagtext ) => {
            return dAPI.delete( `/desires/${ desireid }/tag/${ tagtext }` );
        },
    };
};

export default connect( null, mapDispatchToProps )( NewProductModal );
